import styled from 'styled-components'
import { Icon } from 'react-materialize'
import { ReportType } from '../index'
import { Cell } from '../../../Components/EnterpriseTable'
import { dateFormatter, dateTimeFormatter } from '../../../Utilities/utilities'
import { reportTypes } from '../GenerateReportForm'

const DownloadButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #2c8ef8;
  &:focus {
    background: transparent;
  }
`

type RowProps = {
  report: ReportType
}

const Row = ({ report }: RowProps) => {
  const { parameters } = report,
    startDate = dateFormatter(parameters.startDate, { timeZone: 'UTC' }),
    endDate = dateFormatter(parameters.endDate, { timeZone: 'UTC' }),
    options = [
      reportTypes[report.reportName],
      ...(parameters.source ? [parameters.source] : []),
    ]

  const handleDownload = (url: string | undefined) => {
    if (!url) return

    const a = document.createElement('a')
    a.href = url
    a.click()
  }

  return (
    <tr>
      <Cell>
        {dateFormatter(report.createdDatetime)} at{' '}
        {dateTimeFormatter(report.createdDatetime)}
      </Cell>
      <Cell>{report.label}</Cell>
      <Cell>{options.join(', ')}</Cell>
      <Cell>
        {startDate} - {endDate}
      </Cell>
      <Cell>{report.status}</Cell>
      <Cell align="right">
        {report.status === 'COMPLETE' && (
          <DownloadButton
            type="button"
            onClick={() => handleDownload(report.signedUrl)}
          >
            <Icon>download</Icon>
          </DownloadButton>
        )}
      </Cell>
    </tr>
  )
}

export default Row
